<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>

<router-outlet emTheming></router-outlet>
